<template>
  <div class="website-theme-wrapper">
    <div class="website-theme">
      <div class="website-theme-body">
        <b-field label="Website logo" style="width: 100%;">
          <img :src="$store.state.ASSETS_BASE_URL + '/assets/uploaded/' + currentTheme.webLogo" class="field" />
        </b-field>
        <div class="v-spacer"></div>
        <b-field label="Website Primary Color" style="width: 100%; pointer-events: none;">
          <b-colorpicker v-model="primaryColor" :alpha="alpha" :color-formatter="formatter" />
        </b-field>
        <div class="v-spacer"></div>
        <b-field label="Website Secondary Color" style="width: 100%; pointer-events: none;">
          <b-colorpicker v-model="secondaryColor" :alpha="alpha" :color-formatter="formatter" />
        </b-field>
        <b-field label="Favicon">
          <div class="v-spacer"></div>
          <img :src="$store.state.ASSETS_BASE_URL + '/assets/uploaded/' + currentTheme.webFavicon" class="field" />
        </b-field>
        <b-field label="Title">
          <div class="v-spacer"></div>
          <p>{{ currentTheme.title }}</p>
        </b-field>
        <b-field label="Description">
          <div class="v-spacer"></div>
          <p>{{ currentTheme.description }}</p>
        </b-field>
        <b-field label="Key words(Tags)">
          <div class="v-spacer"></div>
          <b-taglist>
            <b-tag v-for="(tag, index) in keywords" :key="index" type="is-primary is-light">#{{ tag }}</b-tag>
          </b-taglist>

        </b-field>
        <b-field label="Enable landing page">
          <div class="v-spacer"></div>
          <b-switch :value="currentTheme.landingPageEnabled" @input="toogleLangingPage" type="is-info">Info</b-switch>
        </b-field>

        <b-field label="Default initial page">
          <b-input v-model="currentTheme.defaultIndexPage" @input="updateIndexDefaultPage"
            placeholder="Ex:https://watch.rw/event/rwanda-music"></b-input>
        </b-field>

      </div>
      <div class="website-theme-footer">
        <b-button type="is-primary" @click="editWebsiteTheme()">EDIT WEBSITE THEME</b-button>
      </div>
    </div>

    <!-- Edit Modal -->
    <editWebsiteModal v-if="show_edit_modal" @close="show_edit_modal = false" :current="currentTheme"
      @success="refreshUpdate"></editWebsiteModal>
  </div>
</template>

<script>
import Color from "buefy/src/utils/color.js";
import editWebsiteModal from "./edit_website_theme.vue";
export default {
  components: { editWebsiteModal },
  data() {
    return {
      alpha: false,
      show_edit_modal: false,
      currentTheme: {
        webLogo: '',
        webFavicon: '',
        primaryColor: '',
        secondaryColor: '',
        title: '',
        description: '',
        keywords: [],
        landingPageEnabled: false,
        defaultIndexPage: ''
      },
      keywords: [],
      primaryColor: Color.parse('#000000'),
      secondaryColor: Color.parse('#000000'),
      submitingLoading: false,
      resetingLoading: false,
    }
  },
  methods: {
    formatter(color) {
      return color.toString(this.alpha ? 'rgba' : 'rgb')
    },
    resetToDetault() {
      let vm = this;
      vm.resetingLoading = true;
      vm.$store
        .dispatch("ADMIN_USER_RESET_WEBSITE_THEME")
        .then((response) => {
          vm.resetingLoading = false;
          vm.$notify({
            group: "status",
            type: "success",
            title: "Important message",
            text: response.data.message,
          });
          window.location.reload();
        })
        .catch(({ response }) => {
          vm.resetingLoading = false;
        });
    },
    getWebsiteTheme() {
      let vm = this;
      vm.$store
        .dispatch("ADMIN_USER_GET_WEBSITE_THEME")
        .then((response) => {
          if (response.data.return) {
            vm.currentTheme.webLogo = response.data.return.webLogo;
            vm.currentTheme.primaryColor = response.data.return.primaryColor;
            vm.currentTheme.secondaryColor = response.data.return.secondaryColor;
            vm.currentTheme.title = response.data.return.title;
            vm.currentTheme.webFavicon = response.data.return.webFavicon;
            vm.currentTheme.keywords = response.data.return.keywords ? response.data.return.keywords : JSON.stringify([]);
            vm.keywords = vm.currentTheme.keywords ? JSON.parse(vm.currentTheme.keywords) : [];
            vm.currentTheme.description = response.data.return.description;
            vm.currentTheme.landingPageEnabled = response.data.return.landingPageEnabled == 1 ? true : false;
            vm.primaryColor = Color.parse(JSON.parse(vm.currentTheme.primaryColor));
            vm.secondaryColor = Color.parse(JSON.parse(vm.currentTheme.secondaryColor));
            vm.currentTheme.defaultIndexPage = response.data.return.defaultIndexPage;
          }
        })
        .catch(({ response }) => {
        });
    },
    refreshUpdate(changes) {
      let vm = this
      vm.show_edit_modal = false
      if (changes.webLogo == vm.currentTheme.webLogo) {
        vm.getWebsiteTheme();
      } else {
        window.location.reload();
      }
    },
    editWebsiteTheme() {
      let vm = this
      vm.show_edit_modal = true
    },
    toogleLangingPage(value) {
      let vm = this
      vm.$store
        .dispatch("ADMIN_USER_TOGGLE_LANDING_PAGE", { status: value })
        .then((response) => {
          vm.getWebsiteTheme();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Important message",
            text: response.data.message,
          });
        })
        .catch(({ response }) => {
        });
    },
    updateIndexDefaultPage(value) {
      let vm = this
      vm.$store
        .dispatch("ADMIN_USER_UPDATE_DEFAULT_INDEX_PAGE", { url: value })
        .then((response) => {
          vm.getWebsiteTheme();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Important message",
            text: response.data.message,
          });
        })
        .catch(({ response }) => {
        });
    }
  },
  mounted() {
    let vm = this;
    vm.getWebsiteTheme();
  },
}
</script>

<style lang="scss" scoped>
.website-theme-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .website-theme {
    display: flex;
    flex-direction: column;
    height: 100%;

    .website-theme-body {
      overflow-y: auto;
      height: calc(100% - 60px);
      padding: 20px 10px;

      button {
        &.float {
          margin: 0;
          position: sticky;
          top: 20px;
          left: 75%;
        }
      }

      img {
        &.field {
          width: 100px;
        }
      }
    }

    .website-theme-footer {
      padding: 0px 10px;
      border-top: 1px solid #dbdbdb;
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
</style>